import { useEffect, useState } from 'react'

export default function useCopy() {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 4000)
      return () => clearTimeout(timer)
    }
  }, [isCopied])

  const copy = (val: string) => {
    navigator.clipboard.writeText(val)
    setIsCopied(true)
  }

  return { copy, isCopied }
}
